// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableListItem {
  display: flex;
  margin-top: 2px;
  opacity: 0.7;
  cursor: pointer;
  width: 100%;
  border-radius: 5px;
}
.tableListItem:hover {
  opacity: 1;
}
.tableListItem.selected {
  opacity: 1;
}
.tableListItem.selected .itemIndex {
  color: #000;
  background: var(--active-color);
}
.tableListItem.hasWarning .warning {
  display: block;
}
.tableListItem .itemIndex {
  background-color: var(--ui-gray);
  color: var(--text-secondary-color);
  cursor: pointer;
  flex: 1;
  max-width: 25px;
  font-size: 14px;
  font-weight: 400;
  margin-right: 6px;
  padding: 10px;
  text-align: center;
  -webkit-box-sizing: initial;
  -moz-box-sizing: initial;
  box-sizing: initial;
  border-radius: 4px;
}
.tableListItem .itemContent {
  flex: 1;
  color: var(--text-secondary-color);
  width: calc(100% - 51px);
  font-weight: 400;
  margin-top: 9px;
}
.tableListItem .warning-icon {
  display: none;
}
.tableListItem .item-color-section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.tableListItem .item-color {
  margin-top: 8px;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  position: relative;
}
.tableListItem .item-label {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow-wrap: normal;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/tableList/TableListItem.styl"],"names":[],"mappings":"AAAA;EACE,aAAS;EACT,eAAY;EACZ,YAAS;EACT,eAAQ;EACR,WAAO;EACP,kBAAe;AACjB;AACE;EACE,UAAQ;AACZ;AACE;EACE,UAAQ;AACZ;AAAI;EACE,WAAO;EACP,+BAAW;AAEjB;AACI;EACE,cAAS;AACf;AACE;EACE,gCAAkB;EAClB,kCAAO;EACP,eAAQ;EACR,OAAM;EACN,eAAW;EAEX,eAAW;EACX,gBAAa;EACb,iBAAc;EACd,aAAS;EACT,kBAAY;EACZ,2BAAoB;EACpB,wBAAiB;EACjB,mBAAY;EACZ,kBAAe;AAAnB;AAEE;EACE,OAAM;EACN,kCAAO;EACP,wBAAO;EACP,gBAAa;EACb,eAAY;AAAhB;AAEE;EACE,aAAS;AAAb;AAEE;EACE,aAAS;EACT,uBAAiB;EACjB,mBAAa;EACb,sBAAgB;AAApB;AAEE;EACE,eAAY;EACZ,mBAAe;EACf,WAAO;EACP,YAAQ;EACR,kBAAU;AAAd;AAEE;EACE,aAAS;EACT,8BAAiB;EACjB,gBAAU;EACV,eAAW;EACX,uBAAe;EACf,qBAAe;EACf,mBAAa;AAAjB","sourcesContent":[".tableListItem\n  display: flex\n  margin-top: 2px\n  opacity: 0.7\n  cursor: pointer;\n  width: 100%;\n  border-radius: 5px;\n\n  &:hover\n    opacity 1\n\n  &.selected\n    opacity 1\n    .itemIndex\n      color: black\n      background var(--active-color)\n\n  &.hasWarning\n    .warning\n      display: block\n\n  .itemIndex\n    background-color: var(--ui-gray)\n    color: var(--text-secondary-color)\n    cursor: pointer\n    flex: 1\n    max-width: 25px\n    transition(all 0.3s ease)\n    font-size: 14px\n    font-weight: 400\n    margin-right: 6px\n    padding: 10px\n    text-align: center\n    -webkit-box-sizing: initial;\n    -moz-box-sizing: initial;\n    box-sizing: initial;\n    border-radius: 4px;\n\n  .itemContent\n    flex: 1\n    color: var(--text-secondary-color)\n    width: calc(100% - 51px);\n    font-weight: 400\n    margin-top: 9px;\n\n  .warning-icon\n    display: none\n\n  .item-color-section {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .item-color {\n    margin-top: 8px;\n    border-radius: 100%;\n    width: 20px;\n    height: 20px;\n    position: relative;\n  }\n  .item-label {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n    overflow-wrap: normal;\n    white-space: nowrap;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
